import React, { createContext, useCallback, useContext, useMemo, useState } from "react";
import { Spinner } from "@/components/app/Spinner";

const LoadingContext = createContext(null);

export function LoadingProvider({ children }) {
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState("Working…");
  const showLoading = useCallback((m) => { if (m) setMessage(m); setVisible(true); }, []);
  const hideLoading = useCallback(() => setVisible(false), []);
  const runWithLoading = useCallback(async (fn, m) => {
    if (m) setMessage(m);
    setVisible(true);
    try { return await fn(); } finally { setVisible(false); }
  }, []);
  const value = useMemo(() => ({ isLoading: visible, showLoading, hideLoading, runWithLoading }), [visible, showLoading, hideLoading, runWithLoading]);
  return (
    <LoadingContext.Provider value={value}>
      {children}
      {visible ? (
        <div className="fade-in fixed inset-0 z-[9000] flex items-center justify-center bg-black/45 p-8" data-testid="loading-overlay">
          <div className="flex min-w-[220px] max-w-[320px] flex-col items-center rounded-2xl bg-a-surface p-6 shadow-[0_6px_12px_rgba(0,0,0,0.25)]">
            <Spinner size={36} />
            <p className="mt-3 text-[15px] font-bold text-a-text">{message}</p>
            <p className="mt-1 text-center text-xs text-a-muted">Please wait — this may take a few seconds.</p>
          </div>
        </div>
      ) : null}
    </LoadingContext.Provider>
  );
}

export function useLoading() {
  const ctx = useContext(LoadingContext);
  if (!ctx) return { isLoading: false, showLoading: () => {}, hideLoading: () => {}, runWithLoading: async (fn) => fn() };
  return ctx;
}
